module.exports = __webpack_public_path__ + "static/img/beta_bg_white_09.834d6313.svg";